//INFO: (new) 건물 및 층을 조회하는 api

import { instance } from "apis/interceptor";
import { TBuilding } from "types/building.types";

type ResponseType<T> = {
  success: boolean;
  message?: string;
  data?: T;
};

//INFO: (new) 건물을 추가하는 api
export const addBuilding = async (name: string, provider: "MILE" | "GOOGLE"): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.post("/resources/building", { name, provider });
    return { success: true, data: res.data.result };
  } catch (error: any) {
    const status = error.response?.status;
    if (status === 403) {
      return { success: false, message: "권한이 없습니다." };
    }
    return { success: false, message: "건물을 생성할 수 없습니다. 다시 시도해주세요." };
  }
};

//INFO: (new) 건물 내 층 생성하는 api
export const addFloor = async (buildingId: string, name: string): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.post("/resources/floor", { buildingId, name });
    return { success: true, data: res.data.result };
  } catch (error: any) {
    const status = error.response?.status;
    if (status === 403) {
      return { success: false, message: "권한이 없습니다." };
    } else if (status === 404) {
      return { success: false, message: "없는 건물입니다." };
    } else return { success: false, message: "층을 생성할 수 없습니다. 다시 시도해주세요." };
  }
};

//INFO: (new) 건물 이름 수정 api
export const updateBuildingName = async (
  id: string,
  name: string,
  provider: "MILE" | "GOOGLE"
): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.patch(`/resources/building`, { id, name, provider });
    return { success: true, data: res.data.result };
  } catch (error: any) {
    const status = error.response?.status;
    if (status === 403) {
      return { success: false, message: "건물을 수정할 수 있는 권한이 없습니다." };
    } else return { success: false, message: "건물 이름을 수정할 수 없습니다. 다시 시도해주세요." };
  }
};

//INFO: (new) 건물 삭제 api
export const deleteBuilding = async (
  id: string,
  name: string,
  provider: "GOOGLE" | "MILE"
): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.delete(`/resources/building/`, {
      data: {
        id,
        name,
        provider,
      },
    });
    return { success: true, data: res.data.result };
  } catch (error: any) {
    const status = error.response?.status;
    if (status === 403) {
      return { success: false, message: "건물을 삭제할 수 있는 권한이 없습니다." };
    } else if (status === 409) {
      return { success: false, message: `"${name}" 건물이 위치로 등록된 회의실이 존재하여 삭제가 불가능합니다.` };
    }
    return { success: false, message: "건물을 삭제할 수 없습니다. 다시 시도해주세요." };
  }
};

//INFO: (new) 층 삭제 api
export const deleteFloor = async (id: string, name: string): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.delete(`/resources/floor`, {
      data: {
        id,
        name,
      },
    });
    return { success: true, data: res.data.result };
  } catch (error: any) {
    const status = error.response?.status;
    if (status === 403) {
      return { success: false, message: "층을 삭제할 수 있는 권한이 없습니다." };
    } else if (status === 409) {
      return { success: false, message: `"${name}"에 위치로 등록된 회의실이 존재하여 삭제가 불가능합니다.` };
    }
    return { success: false, message: "층을 삭제할 수 없습니다. 다시 시도해주세요." };
  }
};

//INFO: (new) 층 이름 수정 api
export const updateFloorName = async (id: string, name: string): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.patch(`/resources/floor`, { id, name });
    return { success: true, data: res.data.result };
  } catch (error: any) {
    const status = error.response?.status;
    if (status === 403) {
      return { success: false, message: "층을 수정할 수 있는 권한이 없습니다." };
    } else return { success: false, message: "층 이름을 수정할 수 없습니다. 다시 시도해주세요." };
  }
};
